<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.2 3C16.7584 3 16.4 3.3584 16.4 3.8V20.6H21.2V3.8C21.2 3.3584 20.8416 3 20.4 3H17.2ZM2.8 6.2C2.3584 6.2 2 6.5584 2 7V20.6H6.8V7C6.8 6.5584 6.4416 6.2 6 6.2H2.8ZM10 9.4C9.5584 9.4 9.2 9.7584 9.2 10.2V20.6H14V10.2C14 9.7584 13.6416 9.4 13.2 9.4H10Z" fill="currentcolor"/>
</svg>
